module.exports = __webpack_public_path__ + "img/icon-edit.4ddb9ea6.svg";